import { Order } from "./order";

export interface OrderResponse extends Order {
  patientChartId?: number;
  orderId?: string;
}

export namespace OrderResponse {
  export function getCurrentLOC(
    orders: OrderResponse[]
  ): OrderResponse | undefined {
    if (!orders) {
      return undefined;
    }
    // Defined as the LOC order with the most recent start date that is not canceled
    return orders
      .filter(
        (order) => order.orderType == "LEVEL_OF_CARE" && !order.canceledAction
      )
      .sort((a, b) => Date.parse(b.startDate) - Date.parse(a.startDate))[0];
  }
}



// WEBPACK FOOTER //
// ./src/models/order-management/orderResponse.ts